// removed by extract-text-webpack-plugin
module.exports = {"th":"src-components-markdown----th-module---th---2m2D1 padding-s bg-snow borderWidth-0 borderBottomWidth-1 borderRightWidth-1 borderStyle-solid textAlign-center borderColor-smoke--d"};


//////////////////
// WEBPACK FOOTER
// ./src/components/markdown/th.module.css
// module id = 729
// module chunks = 87034247430840 144482056661899